var alignment_default = {
  "alignLeft": "JRsgd",
  "textWrapNowrap": "uZ-nq",
  "alignRight": "ktw6-",
  "alignCenter": "AFuzc",
  "sizeFullWidth": "rrJVo",
  "renderedInTable": "oh8h1",
  "sizeOriginal": "bUob1",
  "sizeContent": "YdMGS",
  "sizeSmall": "hhMfa",
  "sizeSmallCenter": "ItCF9",
  "flex": "xF8OS",
  "LEFT": "NlW6i",
  "CENTER": "oSIQ1",
  "RIGHT": "BofMo",
  "AUTO": "VOLRP",
  "JUSTIFY": "rBggj"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
